import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { ERR_CAN_XFER_REQ, SUC_CAN_XFER_REQ } from '../../../../utils/strings';

export const useCancelTransferRequest = () => {
  const { submit } = useExerciseSubmission(
    TransferRequest.TransferRequest_Cancel,
    SUC_CAN_XFER_REQ,
    ERR_CAN_XFER_REQ,
  );
  return submit;
};
